module.exports = __webpack_public_path__ + "static/img/5.c233bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/5.png
// module id = bGCt
// module chunks = 0